import { render, staticRenderFns } from "./InsuranceCompanyModal.vue?vue&type=template&id=95a13f7a&scoped=true&"
import script from "./InsuranceCompanyModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCompanyModal.vue?vue&type=style&index=0&id=95a13f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a13f7a",
  null
  
)

export default component.exports